/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  AddItemsFromCatalogRequest,
  AddItemsFromCatalogResponse,
  BadRequestException,
  BTFileViewer,
  DeleteItemsFromCatalogRequest,
  DeleteItemsFromCatalogResponse,
  ProblemDetails,
  SaveItemsToCatalogRequest,
  SaveItemsToCatalogResponse,
  SelectionCatalogItemDetail,
  SelectionCatalogListResponse,
  UpdateCatalogItemRequest,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Returns every Selections Catalog option for the current builder shaped for the
catalog grid. Allowances and catalog groups are not part of the pilot.
 */
export const selectionCatalogItemsGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SelectionCatalogListResponse>(
    { url: `/apix/v2/SelectionCatalog/items`, method: "GET", signal },
    options,
  );
};

export const getSelectionCatalogItemsGetV2QueryKey = () => {
  return [`/apix/v2/SelectionCatalog/items`] as const;
};

export const getSelectionCatalogItemsGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof selectionCatalogItemsGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof selectionCatalogItemsGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSelectionCatalogItemsGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof selectionCatalogItemsGetV2>>
  > = ({ signal }) => selectionCatalogItemsGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof selectionCatalogItemsGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SelectionCatalogItemsGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof selectionCatalogItemsGetV2>>
>;
export type SelectionCatalogItemsGetV2QueryError = ErrorType<ProblemDetails>;

/**
 * @summary Returns every Selections Catalog option for the current builder shaped for the
catalog grid. Allowances and catalog groups are not part of the pilot.
 */

export function useSelectionCatalogItemsGetV2<
  TData = Awaited<ReturnType<typeof selectionCatalogItemsGetV2>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof selectionCatalogItemsGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSelectionCatalogItemsGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Returns the read-only detail (option metadata, line items, attachments) for a single
catalog option. Used by the catalog detail side panel. Catalog options are
builder-scoped; no jobId is required.
 */
export const selectionCatalogItemsByCatalogOptionIdGetV2 = (
  catalogOptionId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SelectionCatalogItemDetail>(
    {
      url: `/apix/v2/SelectionCatalog/items/${catalogOptionId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getSelectionCatalogItemsByCatalogOptionIdGetV2QueryKey = (
  catalogOptionId?: number,
) => {
  return [`/apix/v2/SelectionCatalog/items/${catalogOptionId}`] as const;
};

export const getSelectionCatalogItemsByCatalogOptionIdGetV2QueryOptions = <
  TData = Awaited<
    ReturnType<typeof selectionCatalogItemsByCatalogOptionIdGetV2>
  >,
  TError = ErrorType<ProblemDetails>,
>(
  catalogOptionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof selectionCatalogItemsByCatalogOptionIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSelectionCatalogItemsByCatalogOptionIdGetV2QueryKey(catalogOptionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof selectionCatalogItemsByCatalogOptionIdGetV2>>
  > = ({ signal }) =>
    selectionCatalogItemsByCatalogOptionIdGetV2(
      catalogOptionId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!catalogOptionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof selectionCatalogItemsByCatalogOptionIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SelectionCatalogItemsByCatalogOptionIdGetV2QueryResult =
  NonNullable<
    Awaited<ReturnType<typeof selectionCatalogItemsByCatalogOptionIdGetV2>>
  >;
export type SelectionCatalogItemsByCatalogOptionIdGetV2QueryError =
  ErrorType<ProblemDetails>;

/**
 * @summary Returns the read-only detail (option metadata, line items, attachments) for a single
catalog option. Used by the catalog detail side panel. Catalog options are
builder-scoped; no jobId is required.
 */

export function useSelectionCatalogItemsByCatalogOptionIdGetV2<
  TData = Awaited<
    ReturnType<typeof selectionCatalogItemsByCatalogOptionIdGetV2>
  >,
  TError = ErrorType<ProblemDetails>,
>(
  catalogOptionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof selectionCatalogItemsByCatalogOptionIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getSelectionCatalogItemsByCatalogOptionIdGetV2QueryOptions(
      catalogOptionId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Updates the metadata and line items of a single catalog option and returns the
refreshed detail. Replaces all existing line items with the provided list.
 */
export const selectionCatalogItemsByCatalogOptionIdPutV2 = (
  catalogOptionId: number,
  updateCatalogItemRequest: BodyType<UpdateCatalogItemRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<SelectionCatalogItemDetail>(
    {
      url: `/apix/v2/SelectionCatalog/items/${catalogOptionId}`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: updateCatalogItemRequest,
    },
    options,
  );
};

export const getSelectionCatalogItemsByCatalogOptionIdPutV2MutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionCatalogItemsByCatalogOptionIdPutV2>>,
    TError,
    { catalogOptionId: number; data: BodyType<UpdateCatalogItemRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionCatalogItemsByCatalogOptionIdPutV2>>,
  TError,
  { catalogOptionId: number; data: BodyType<UpdateCatalogItemRequest> },
  TContext
> => {
  const mutationKey = ["selectionCatalogItemsByCatalogOptionIdPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionCatalogItemsByCatalogOptionIdPutV2>>,
    { catalogOptionId: number; data: BodyType<UpdateCatalogItemRequest> }
  > = (props) => {
    const { catalogOptionId, data } = props ?? {};

    return selectionCatalogItemsByCatalogOptionIdPutV2(
      catalogOptionId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionCatalogItemsByCatalogOptionIdPutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof selectionCatalogItemsByCatalogOptionIdPutV2>>
  >;
export type SelectionCatalogItemsByCatalogOptionIdPutV2MutationBody =
  BodyType<UpdateCatalogItemRequest>;
export type SelectionCatalogItemsByCatalogOptionIdPutV2MutationError =
  ErrorType<ProblemDetails>;

/**
 * @summary Updates the metadata and line items of a single catalog option and returns the
refreshed detail. Replaces all existing line items with the provided list.
 */
export const useSelectionCatalogItemsByCatalogOptionIdPutV2 = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionCatalogItemsByCatalogOptionIdPutV2>>,
    TError,
    { catalogOptionId: number; data: BodyType<UpdateCatalogItemRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionCatalogItemsByCatalogOptionIdPutV2>>,
  TError,
  { catalogOptionId: number; data: BodyType<UpdateCatalogItemRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionCatalogItemsByCatalogOptionIdPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Returns the full file viewer (files, viewing permissions, upload options) for a single
catalog option. Used by the catalog detail side panel's attachment section. Catalog
options are builder-scoped; no jobId is required.
 */
export const selectionCatalogItemsAttachmentsByCatalogOptionIdGetV2 = (
  catalogOptionId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BTFileViewer>(
    {
      url: `/apix/v2/SelectionCatalog/items/${catalogOptionId}/attachments`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getSelectionCatalogItemsAttachmentsByCatalogOptionIdGetV2QueryKey =
  (catalogOptionId?: number) => {
    return [
      `/apix/v2/SelectionCatalog/items/${catalogOptionId}/attachments`,
    ] as const;
  };

export const getSelectionCatalogItemsAttachmentsByCatalogOptionIdGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof selectionCatalogItemsAttachmentsByCatalogOptionIdGetV2>
    >,
    TError = ErrorType<ProblemDetails>,
  >(
    catalogOptionId: number,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof selectionCatalogItemsAttachmentsByCatalogOptionIdGetV2
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getSelectionCatalogItemsAttachmentsByCatalogOptionIdGetV2QueryKey(
        catalogOptionId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof selectionCatalogItemsAttachmentsByCatalogOptionIdGetV2
        >
      >
    > = ({ signal }) =>
      selectionCatalogItemsAttachmentsByCatalogOptionIdGetV2(
        catalogOptionId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!catalogOptionId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof selectionCatalogItemsAttachmentsByCatalogOptionIdGetV2
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type SelectionCatalogItemsAttachmentsByCatalogOptionIdGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof selectionCatalogItemsAttachmentsByCatalogOptionIdGetV2>
    >
  >;
export type SelectionCatalogItemsAttachmentsByCatalogOptionIdGetV2QueryError =
  ErrorType<ProblemDetails>;

/**
 * @summary Returns the full file viewer (files, viewing permissions, upload options) for a single
catalog option. Used by the catalog detail side panel's attachment section. Catalog
options are builder-scoped; no jobId is required.
 */

export function useSelectionCatalogItemsAttachmentsByCatalogOptionIdGetV2<
  TData = Awaited<
    ReturnType<typeof selectionCatalogItemsAttachmentsByCatalogOptionIdGetV2>
  >,
  TError = ErrorType<ProblemDetails>,
>(
  catalogOptionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof selectionCatalogItemsAttachmentsByCatalogOptionIdGetV2
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getSelectionCatalogItemsAttachmentsByCatalogOptionIdGetV2QueryOptions(
      catalogOptionId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Saves one or more items (Selection Options today; Allowances and other entity types later)
to the Selections Catalog. Returns the new catalog option IDs in the same order as the input.
 */
export const selectionCatalogSaveItemsPostV2 = (
  saveItemsToCatalogRequest: BodyType<SaveItemsToCatalogRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SaveItemsToCatalogResponse>(
    {
      url: `/apix/v2/SelectionCatalog/save-items`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: saveItemsToCatalogRequest,
      signal,
    },
    options,
  );
};

export const getSelectionCatalogSaveItemsPostV2MutationOptions = <
  TError = ErrorType<BadRequestException | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionCatalogSaveItemsPostV2>>,
    TError,
    { data: BodyType<SaveItemsToCatalogRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionCatalogSaveItemsPostV2>>,
  TError,
  { data: BodyType<SaveItemsToCatalogRequest> },
  TContext
> => {
  const mutationKey = ["selectionCatalogSaveItemsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionCatalogSaveItemsPostV2>>,
    { data: BodyType<SaveItemsToCatalogRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return selectionCatalogSaveItemsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionCatalogSaveItemsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof selectionCatalogSaveItemsPostV2>>
>;
export type SelectionCatalogSaveItemsPostV2MutationBody =
  BodyType<SaveItemsToCatalogRequest>;
export type SelectionCatalogSaveItemsPostV2MutationError = ErrorType<
  BadRequestException | ProblemDetails
>;

/**
 * @summary Saves one or more items (Selection Options today; Allowances and other entity types later)
to the Selections Catalog. Returns the new catalog option IDs in the same order as the input.
 */
export const useSelectionCatalogSaveItemsPostV2 = <
  TError = ErrorType<BadRequestException | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionCatalogSaveItemsPostV2>>,
    TError,
    { data: BodyType<SaveItemsToCatalogRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionCatalogSaveItemsPostV2>>,
  TError,
  { data: BodyType<SaveItemsToCatalogRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionCatalogSaveItemsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Copies one or more catalog options (along with catalog line items + attachments)
onto the target job. Returns the new SelectionOptionIDs
 */
export const selectionCatalogAddItemsPostV2 = (
  addItemsFromCatalogRequest: BodyType<AddItemsFromCatalogRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AddItemsFromCatalogResponse>(
    {
      url: `/apix/v2/SelectionCatalog/add-items`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: addItemsFromCatalogRequest,
      signal,
    },
    options,
  );
};

export const getSelectionCatalogAddItemsPostV2MutationOptions = <
  TError = ErrorType<BadRequestException | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionCatalogAddItemsPostV2>>,
    TError,
    { data: BodyType<AddItemsFromCatalogRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionCatalogAddItemsPostV2>>,
  TError,
  { data: BodyType<AddItemsFromCatalogRequest> },
  TContext
> => {
  const mutationKey = ["selectionCatalogAddItemsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionCatalogAddItemsPostV2>>,
    { data: BodyType<AddItemsFromCatalogRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return selectionCatalogAddItemsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionCatalogAddItemsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof selectionCatalogAddItemsPostV2>>
>;
export type SelectionCatalogAddItemsPostV2MutationBody =
  BodyType<AddItemsFromCatalogRequest>;
export type SelectionCatalogAddItemsPostV2MutationError = ErrorType<
  BadRequestException | ProblemDetails
>;

/**
 * @summary Copies one or more catalog options (along with catalog line items + attachments)
onto the target job. Returns the new SelectionOptionIDs
 */
export const useSelectionCatalogAddItemsPostV2 = <
  TError = ErrorType<BadRequestException | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionCatalogAddItemsPostV2>>,
    TError,
    { data: BodyType<AddItemsFromCatalogRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionCatalogAddItemsPostV2>>,
  TError,
  { data: BodyType<AddItemsFromCatalogRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionCatalogAddItemsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Deletes one or more items from the Selections Catalog and their associated line items
 */
export const selectionCatalogDeleteItemsDeleteV2 = (
  deleteItemsFromCatalogRequest: BodyType<DeleteItemsFromCatalogRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<DeleteItemsFromCatalogResponse>(
    {
      url: `/apix/v2/SelectionCatalog/delete-items`,
      method: "DELETE",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: deleteItemsFromCatalogRequest,
    },
    options,
  );
};

export const getSelectionCatalogDeleteItemsDeleteV2MutationOptions = <
  TError = ErrorType<BadRequestException | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionCatalogDeleteItemsDeleteV2>>,
    TError,
    { data: BodyType<DeleteItemsFromCatalogRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectionCatalogDeleteItemsDeleteV2>>,
  TError,
  { data: BodyType<DeleteItemsFromCatalogRequest> },
  TContext
> => {
  const mutationKey = ["selectionCatalogDeleteItemsDeleteV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectionCatalogDeleteItemsDeleteV2>>,
    { data: BodyType<DeleteItemsFromCatalogRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return selectionCatalogDeleteItemsDeleteV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectionCatalogDeleteItemsDeleteV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof selectionCatalogDeleteItemsDeleteV2>>
>;
export type SelectionCatalogDeleteItemsDeleteV2MutationBody =
  BodyType<DeleteItemsFromCatalogRequest>;
export type SelectionCatalogDeleteItemsDeleteV2MutationError = ErrorType<
  BadRequestException | ProblemDetails
>;

/**
 * @summary Deletes one or more items from the Selections Catalog and their associated line items
 */
export const useSelectionCatalogDeleteItemsDeleteV2 = <
  TError = ErrorType<BadRequestException | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectionCatalogDeleteItemsDeleteV2>>,
    TError,
    { data: BodyType<DeleteItemsFromCatalogRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectionCatalogDeleteItemsDeleteV2>>,
  TError,
  { data: BodyType<DeleteItemsFromCatalogRequest> },
  TContext
> => {
  const mutationOptions =
    getSelectionCatalogDeleteItemsDeleteV2MutationOptions(options);

  return useMutation(mutationOptions);
};
